import React from 'react';
//import { theme } from 'constants'
import { Text } from 'core';
//import { lang } from 'lang'

const Account = ({ user }) => <Text>suggestion</Text>;
export default Account;



// WEBPACK FOOTER //
// ./src/components/middle/settings/suggestions.js